import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-competition',
  templateUrl: './competition.component.html',
  styleUrls: ['./competition.component.scss']
})
export class CompetitionComponent implements OnInit {
  activeFilter: string = '.all';
  constructor() { }

  ngOnInit(): void {
  }

  filterInnerTabs(year: string, event: Event, containerId: string): void {
    const clickedElement = event.target as HTMLElement;

    // Remove 'active' from all sibling buttons
    const buttons = clickedElement.parentElement?.querySelectorAll('.nav-link');
    buttons?.forEach(btn => btn.classList.remove('active'));
    clickedElement.classList.add('active');

    // Select cards only inside the specified container
    const container = document.getElementById(containerId);
    if (!container) return;

    const cards = container.querySelectorAll('[data-year]');
    cards.forEach(card => {
      const htmlCard = card as HTMLElement;
      const cardYear = htmlCard.getAttribute('data-year');
      htmlCard.style.display = (year === 'all' || cardYear === year) ? 'block' : 'none';
    });
  }

}
